<template>
  <div>
    <template>
      <h4
        class="not-margin"
        :style="{
          fontWeight: 'bold',
          color: '#195BFF',
          fontSize: '18px',
          marginTop: '10px',
        }"
      >
        <i
          class="fal fa-sync-alt"
          :style="{ width: '30px', fontSize: '18px' }"
        ></i>
        ຍົກເລີກມາກວດສອບການເຄື່ອນໄຫວ
      </h4>
    </template>

    <div class="info-box" :style="{ marginTop: '15px' }">
      <p><strong>ເລກບິນ:</strong> {{ shipment_number }}</p>
      <p class="warning-text">
        <i class="fal fa-exclamation-triangle"></i>
        ການດຳເນີນການນີ້ຈະຍົກເລີກມາກວດສອບການເຄື່ອນໄຫວຂອງບິນ
      </p>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="button is-success"
        @click="handleSubmit"
        :disabled="isLoading"
      >
        <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
        <i v-else class="fal fa-check"></i>
        ຢືນຢັນ
      </button>
      <button
        type="button"
        class="button btn-clear"
        @click="$emit('close')"
      >
        ຍົກເລີກ
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateBranchSwap',

  props: {
    shipment_number: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    handleSubmit() {
      this.isLoading = true;

      const payload = {
        shipment_number: this.shipment_number
      };

      this.$axios.post('shipment/update-branch-swap', payload)
        .then((response) => {
          const data = response.data?.data || response.data;

          this.$vs.notification({
            color: 'success',
            title: 'ສຳເລັດ',
            text: `ສະຫຼັບສາຂາສຳເລັດ: ຕົ້ນທາງໃໝ່ ID ${data.new_start_branch_id}, ປາຍທາງໃໝ່ ID ${data.new_end_branch_id}`
          });
          this.$emit('success');
          this.$emit('close');
        })
        .catch(error => {
          this.isLoading = false;

          let errorMessage = 'ເກີດຂໍ້ຜິດພາດ';
          if (error.response && error.response.data) {
            errorMessage = error.response.data.message || errorMessage;
          }

          this.$vs.notification({
            color: 'danger',
            title: 'ຂໍ້ຜິດພາດ',
            text: errorMessage
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.info-box {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  border-left: 4px solid #195BFF;
}

.warning-text {
  color: #856404;
  background: #fff3cd;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0;
}

.warning-text i {
  margin-right: 8px;
}

.swap-info {
  margin-top: 10px;
  padding-left: 20px;
}

.swap-info li {
  margin-bottom: 5px;
  color: #495057;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.btn-clear {
  background: #dc3545;
  color: white;
}

.btn-clear:hover {
  background: #c82333;
  color: white;
}
</style>
